import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  SEARCH_TOUR,
  WHO_GO_LABEL,
  FROM_LABEL,
  HOTEL_LABEL,
  TO_LABEL,
  WHEN_LABEL,
  NIGHTS_LABEL,
  FROM_ID,
  HOTEL_ID,
  TO_ID,
  WHEN_ID,
  TOURISTS_ID,
  NIGHTS_ID,
} from '../../../Utils/Constants/HomePageConstants';
import { HOTEL_DETAILS } from '../../../Utils/Constants/GlobalConstants';
import {
  changeCharterOnly,
  changeSelectedResorts,
} from '../../../DataStore/actions/searchFormActions';
import {
  changeSelectedHotels,
  changeIsAllRegionsFilterTab,
} from '../../../DataStore/actions/FiltersAction';
import {
  firstLetterInUpperCase,
  getShortString,
} from '../../../Utils/CommonUtils';
import './css/DesctopSearchForm.css';
import { ReactComponent as Calendar } from '../../../images/calendar-r.svg';
import { ReactComponent as Arrow } from '../../../images/arrow-bottom-black-r.svg';
import Input from '../Input/Input';

const mapStateToProps = (state) => ({ ...state });

class DesctopSearchForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { isDisabled, page, hotel, handleSubmit } = this.props;

    return (
      <div className="sf_wrap">
        <div className="sf_item">
          <Input label={FROM_LABEL} id={FROM_ID} isDesctop />
        </div>
        <div className="sf_item sf_destination_item">
          {page === HOTEL_DETAILS ? (
            <Input
              label={HOTEL_LABEL}
              id={HOTEL_ID}
              value={getShortString(firstLetterInUpperCase(hotel), 25)}
              isDesctop
            />
          ) : (
            <Input label={TO_LABEL} id={TO_ID} isDesctop />
          )}
        </div>
        <div className="sf_item sf_calendar_item">
          <Input label={WHEN_LABEL} id={WHEN_ID} ico={<Calendar />} isDesctop />
        </div>
        <div className="sf_item">
          <Input label={NIGHTS_LABEL} id={NIGHTS_ID} isDesctop />
        </div>
        <div className="sf_item sf_tourists_item">
          <Input
            label={WHO_GO_LABEL}
            id={TOURISTS_ID}
            ico={<Arrow />}
            isDesctop
          />
        </div>
        <div className="sf_item sf_search_item">
          <div className="sf_search_button_w">
            <button
              type="button"
              className="sf_search_button bm_text_18"
              onClick={handleSubmit}
              disabled={isDisabled}
            >
              {SEARCH_TOUR}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

DesctopSearchForm.propTypes = {
  isDisabled: PropTypes.bool,
  page: PropTypes.string.isRequired,
  hotel: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
};

DesctopSearchForm.defaultProps = {
  isDisabled: false,
  hotel: '',
};

export default connect(mapStateToProps, {
  changeCharterOnly,
  changeSelectedHotels,
  changeSelectedResorts,
  changeIsAllRegionsFilterTab,
})(DesctopSearchForm);
